import { trackEvent } from '@finn-no/pulse-sdk';

// Pulse tracker id: TR_ev10 and TR_ev11 (see tracking section in README.md)
export const trackOpenVerticalClick = (vertical: string, path: string) =>
    trackEvent({
        type: 'Click',
        intent: 'Open',
        name: `Open ${vertical}`,
        object: {
            // @ts-ignore seems the typing in pulse-sdk is wrong
            id: undefined,
            type: 'UIElement',
            elementType: 'Link',
        },
        target: {
            id: path,
            type: vertical === 'currency' ? 'Page' : 'Listing',
            name: `Go to ${vertical}`,
        },
        vertical: {
            name: 'travel',
            subVertical: vertical,
        },
    });
